import React from 'react'
import GalleryComponent from '../../components/GalleryComponent/GalleryComponent'
import SafariBlog from '../../components/SafariBlog/SafariBlog'

import gallery_1 from '../../assets/images/herping-1.webp'
import gallery_2 from '../../assets/images/herping-2.jpg'
import gallery_3 from '../../assets/images/herping-3.webp'
import gallery_4 from '../../assets/images/herping-4.webp'
import gallery_5 from '../../assets/images/herping-5.webp'
import gallery_6 from '../../assets/images/herping-6.webp'
import gallery_7 from '../../assets/images/herping-7.webp'
import gallery_8 from '../../assets/images/herping-8.webp'
import gallery_9 from '../../assets/images/herping-9.webp'
import gallery_10 from '../../assets/images/herping-10.webp'
import gallery_11 from '../../assets/images/herping-11.webp'
import gallery_12 from '../../assets/images/herping-12.webp'
import gallery_13 from '../../assets/images/herping-13.webp'
import gallery_14 from '../../assets/images/herping-14.webp'
import gallery_15 from '../../assets/images/herping-15.webp'
import gallery_16 from '../../assets/images/herping-16.webp'


const descriptions = [
    'With more than 110 species of amphibians and 250 reptiles, Sri Lanka is a herping paradise. We would be touring in the best locations to easily see some of these elusive creature. In our lowland rainforest tours, you would be able to see the Sri Lankan green pit viper (Peltopelor trigonocaphalus), the Rough horned lizard (Ceratophora aspera), the lyre headed lizard (Lyriocephalus scutatus) and many more. In the montane forests of Horton plains, you can see the iconic Rhino horned lizard (Ceratophora stoddartii), the Sri Lankan Pygmy Lizard and the Black-cheeked lizard (Calotes nigrilabris). Then we would tour on the knuckles mountain region, where you would see the leaf nosed lizard (Ceratophora tennentii), Knuckles pygmy lizard (Cophotis dumbara), and Pethiyagoda’s lizard (Calotes pethiyagodai). Noteworthy amphibians in the region would be the Asanka’s shrub frog (Pseudophilautus asankai) that comes in many different colour morphs, Moore’s shrub frog (Pseudophilautus mooreorum) and the Stuart’s shrub frog (Pseudophilautus stuarti).',

    'In the rakwana mountains, you may be lucky enough to see the smallest lizard of Sri Lanka, Karu’s horned lizard (Ceratophora karu). Also the region is filled with point endemic amphibians like Poppie’s shrub frog (Pseudophilautus poppiae) and the Golden eyed shrub frog (Pseudophilautus ocularis). Sri Lanka is a country with high human-snake conflict, containing several deadly venomous species, so visitors are always advice to follow the tour guides instructions. During our tours, you may be able to see some of these venomous creatures, like the Indian cobra (Naja naja), Merrem’s hump nosed pit viper (Hypnale hypnale), and the Russel’s viper (Daboia russelii). You may commonly encounter the harmless species such as the Green vine snake (Ahaetulla nasuta), Sri Lankan cat snake (Boiga ceylonensis) and Sri Lankan wolf snake (Lycodon carinatus).',
  ];

const wildlife_photography = () => {

    const items = [
        { xs: 4, imgSrc: gallery_1 },
        { xs: 4, imgSrc: gallery_2 },
        { xs: 4, imgSrc: gallery_3 },
        { xs: 3.5, imgSrc: gallery_4 },
        { xs: 3.5, imgSrc: gallery_5 },
        { xs: 5, imgSrc: gallery_6 },
        { xs: 4, imgSrc: gallery_7 },
        { xs: 4, imgSrc: gallery_8 },
        { xs: 4, imgSrc: gallery_9 },
        { xs: 3, imgSrc: gallery_10 },
        { xs: 3, imgSrc: gallery_11 },
        { xs: 3, imgSrc: gallery_12 },
        { xs: 3, imgSrc: gallery_13 },
        { xs: 3, imgSrc: gallery_14 },
        { xs: 3, imgSrc: gallery_15 },
        { xs: 6, imgSrc: gallery_16 },
    ];

  return <div className='__black'>
    <SafariBlog
        heading='Herping Tours'
        description={descriptions}
        to='/contact'
    />
    <div className="w-1">
        <GalleryComponent imgStyle={{padding:'10px', height:'40vh'}} items={items} />;
    </div>
  </div>
}

export default wildlife_photography